import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-progress',
  standalone: true,
  imports: [],
  templateUrl: './ui-progress.component.html',
  styleUrl: './ui-progress.component.scss'
})
export class UiProgressComponent {
  @Input() value: number = 0;
  @Input() max: number = 100;
  @Input() color: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error' = 'primary';
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'md';

  get percentage(): number {
    if (this.max <= 0) return 0;
    return Math.min(100, Math.max(0, (this.value / this.max) * 100));
  }

}

